import agena from 'agena-api-js';
import ModellerReducer from './ModellerReducer';
import ModellerDefaults from './ModellerDefaults';
import UiReducer from '../shared/state/UiReducer';
import keycloak from '../shared/Keycloak';

const calculate = async (globalState, dispatch, isInterrupted, cleanup, appId, modelPath, mode) => {
  // agena.init({ api: { server: 'https://api.onprem.example.org', debug: true, debugLevel: 10 } });
  agena.init({ api: { server: window.env.REACT_APP_API_ROOT } });

  const model = ModellerReducer.getModel(globalState);
  if (!model?.networks) {
    dispatch(UiReducer.uiSetErrors(['No model to calculate']));
    return;
  }

  dispatch(UiReducer.uiSetErrors());

  const headers = {
    'x-referer': window.location.href,
  };
  const userId = UiReducer.getGenericUiAttribute(globalState, UiReducer.Keys.userId);
  if (userId) {
    headers['User-Id'] = userId;
  }

  const responses = {};
  const errors = [];
  const results = await agena.calculateBatch({
    resolveBearerToken: () => {
      if (keycloak.authenticated && keycloak.token) {
        return keycloak.token;
      }
      return '';
    },
    ...(appId && { appId }),
    ...(modelPath && { modelPath }),
    ...(!modelPath && {
      model: {
        ...model,
        dataSets: [],
        graphics: {},
        riskTable: {},
      },
    }),
    ...(mode && { mode }),
    dataSets: model.dataSets.map((ds) => ({ ...ds, results: [] })),
    errorsArray: errors,
    isInterrupted,
    headers,
    rawResponses: responses,
  });

  console.log('results:', results);
  console.log('errors:', errors);
  console.log('responses', responses);

  Object.keys(responses).forEach((datasetId) => {
    dispatch(ModellerReducer.cacheCalculationResponse(datasetId, responses[datasetId]));
  });

  if (typeof isInterrupted === 'function' && !isInterrupted()) {
    // Ignore errors if request interrupted by user
    if (errors.length > 0) {
      console.log('errors.length > 0');
      // Show errors and possibly proceed
      dispatch(UiReducer.uiSetErrors(errors));

      if (!results || results.length === 0) {
        // Only exit if there are no calculated datasets
        dispatch(UiReducer.uiSetLoading(false));
        if (typeof cleanup === 'function') {
          cleanup();
        }
        return;
      }
    }
  }

  if (results) {
    const updatedModel = { ...model };
    const idIndexMap = {};
    const indexIdMap = {};

    model.dataSets.forEach((dataset, i) => {
      idIndexMap[dataset.id] = i;
      indexIdMap[i] = dataset.id;
    });

    results.forEach((dataset) => {
      // console.log('update ds ', dataset.id, ' on index ', idIndexMap[dataset.id], 'to ', dataset.results);
      updatedModel.dataSets[idIndexMap[dataset.id]].results = dataset.results;
      updatedModel.dataSets = [...updatedModel.dataSets];
    });

    // Clear chart CSS backgrounds for nodes in mode_plain so they don't retain outdated charts
    if (updatedModel.networks) {
      updatedModel.networks.forEach((network) => {
        if (network.nodes) {
          network.nodes.forEach((node) => {
            const nodeGraphics = node.graphics || ModellerDefaults.DefaultGraphics;
            const graphGraphics = nodeGraphics.graph || ModellerDefaults.DefaultGraphics.graph;
            const graphClasses = graphGraphics.classes || [];
            const isModeChart = graphClasses.includes(`mode_${ModellerDefaults.NodeModes.CHART}`);
            const isModePlain = graphClasses.includes(`mode_${ModellerDefaults.NodeModes.PLAIN}`) || !isModeChart;

            // If node is in mode_plain (or not explicitly mode_chart), remove any existing chart background
            // eslint-disable-next-line camelcase
            if (isModePlain && graphGraphics.style?.custom?.mode_chart) {
              // eslint-disable-next-line camelcase
              if (graphGraphics.style.custom.mode_chart['background-image']) {
                // eslint-disable-next-line camelcase
                delete graphGraphics.style.custom.mode_chart['background-image'];
                // Clean up empty mode_chart object if it's now empty
                if (Object.keys(graphGraphics.style.custom.mode_chart).length === 0) {
                  delete graphGraphics.style.custom.mode_chart;
                }
                // Clean up empty custom object if it's now empty
                if (Object.keys(graphGraphics.style.custom).length === 0) {
                  delete graphGraphics.style.custom;
                }
              }
            }
          });
        }
      });
    }

    dispatch(ModellerReducer.updateModel(updatedModel));
    // Map results immediately so they're available for chart rendering
    dispatch(ModellerReducer.mapResults(updatedModel, Date.now()));
    // Set render flag after results are mapped
    dispatch(ModellerReducer.setSetting(ModellerReducer.SettingKeys.renderChartsRequested, Date.now()));
    console.log('Calculated model', updatedModel);
  }

  dispatch(UiReducer.uiSetLoading(false));
  if (typeof cleanup === 'function') {
    cleanup();
  }
};

export default {
  calculate,
};
